<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_bill_retrospect">
                <img src="@/assets/icon-restaurant-bill.png">
            </div>
            <h2 class="title_bill_retrospect">บิลวันนี้</h2>
        </div>

        <v-btn class="grad-primary-bg white--text titlefont_bill_retrospect" height="50" width="20%" @click="$router.push('/poslist')">
            ย้อนกลับ
        </v-btn>
    </div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">ยกเลิกบิลเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="message_remove_money_in_out === true">ยกเลิกเงินเข้าเรียบร้อยแล้ว</v-alert>
        <v-alert type="warning" class="alert_success" v-if="alert_waiting === true">กำลังทำการพิมพ์ใบเสร็จกรุณารอสักครู่...</v-alert>
    </v-slide-x-reverse-transition>

    <v-card>
        <v-tabs grow>
            <v-tab @click="changePage(1)">รายการบิลย้อนหลังวันนี้</v-tab>
            <v-tab @click="changePage(2)">รายการรับเงินเข้าวันนี้</v-tab>
        </v-tabs>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <div v-if="page === 1">
                <v-card-title>
                    <v-text-field v-model="bill_search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="bill_headers" :items="bill_list" :search="bill_search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.invoin_code}}</td>
                            <td>{{dataDetail.item.time}}</td>
                            <td>{{dataDetail.item.type}} <span v-if="dataDetail.item.table_no != 'สั่งกลับบ้าน'">(โต๊ะ {{ dataDetail.item.table_no }})</span></td>
                            <td>{{dataDetail.item.user_cancel}}</td>
                            <td>{{ Intl.NumberFormat().format(dataDetail.item.total_price)}}</td>
                            <td :class="dataDetail.item.payment_method == 'สด' ? 'success--text': dataDetail.item.payment_method == 'โอน' || dataDetail.item.payment_method == 'เดรบิต/เครดิต' ? 'warning--text' : dataDetail.item.payment_method == 'โครงการรัฐ' ? 'primary--text' : ''" @click="changetypepay(dataDetail.item.id,dataDetail.item.invoin_code)">{{dataDetail.item.payment_method}}</td>
                            <td>
                                <v-btn color="error" v-if="dataDetail.item.status == 'ยกเลิกบิล'" @click="confirmBill(dataDetail.item.id,dataDetail.item.invoin_code)">{{ dataDetail.item.status }}</v-btn>
                                <div class="error--text" v-if="dataDetail.item.status == 'บิลถูกยกเลิก'">{{ dataDetail.item.status }}</div>
                            </td>
                            <td>
                                <span class="detail_bill_retrospect" @click="detailBill(dataDetail.item.id)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            <div v-if="page === 2">
                <v-card-title>
                    <v-text-field v-model="money_search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="money_headers" :items="money_list" :search="money_search">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.name == null || '' ? '-' : dataDetail.item.name}}</td>
                            <td>{{dataDetail.item.created_at}}</td>
                            <td>{{dataDetail.item.price}}</td>
                            <td v-if="dataDetail.item.status_delete === 0" :class="dataDetail.item.status === 'เงินสด' ? 'success--text' : ''" :style="dataDetail.item.status === 'เงินโอน' ? 'color:#2f4f4f;' : ''">{{dataDetail.item.status}}</td>
                            <td v-if="dataDetail.item.status_delete === 0">{{dataDetail.item.description}}</td>
                            <td v-if="dataDetail.item.status_delete === 1" class="error--text">{{ dataDetail.item.status }}</td>
                            <td v-if="dataDetail.item.status_delete === 1">{{dataDetail.item.description}}</td>
                            <td>
                                <v-btn color="error" v-if="dataDetail.item.status_delete == 0" @click="cancelMoneyInOut(dataDetail.item.id)">{{dataDetail.item.action}}</v-btn>
                                <div class="error--text" v-if="dataDetail.item.status_delete == 1">{{dataDetail.item.action}}</div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>
    </v-card>
    <v-dialog v-model="confirm_bill" persistent max-width="600">
        <div v-if="loading_page_detail === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>

        <v-card v-if="loading_page_detail === false">
            <v-form ref="form_successbill" @submit.prevent="successBill()">
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการยกเลิกบิล {{ bill_invoin_code }} ใช่หรือไม่ ?
                    </div>
                    <div class="mb-2">
                        <v-select label="เหตุผลในการยกเลิกบิล" v-model="bill_description" :items="$store.state.reasonCancelBill" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกบิล']" @change="billCancelDescription()" required outlined>
                        </v-select>
                    </div>
                    <div class="mb-2" v-if="bill_description_reason_check">
                        <v-text-field v-model="bill_description_reason" color="primary" label="เหตุผลในการยกเลิกบิล" :rules="[v => !!v || 'กรุณากรอกเหตุผลในการยกเลิกบิล']" required outlined></v-text-field>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="cancelBill()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <v-dialog v-model="change_type_pay" persistent max-width="600">
        <div v-if="loading_page_detail === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>

        <v-card v-if="loading_page_detail === false">
            <v-form ref="form_successchangepay" @submit.prevent="successChangePay()">
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการเปลี่ยนประเภทการชำระเงิน ใช่หรือไม่ ?
                    </div>
                    <div class="mb-2">
                        <v-select label="เลือกประเภทการชำระเงิน" v-model="change_description" :items="change_pay_headers" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกบิล']" required outlined>
                        </v-select>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="canceltypepay()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <v-dialog v-model="detail_bill" persistent max-width="600">
        <div v-if="loading_page_detail_bill === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_detail_bill === false">
            <v-card-title class="justify-end">
                <div class="cursor_bill_retrospect" @click="detail_bill = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>
            <v-card-text>
                <h2 class="mb-2 error--text" v-if="data_bill_detail.description_delete">
                    หมายเหตุในการยกเลิกบิล ?
                </h2>
                <h2 class="mb-2 error--text" v-if="data_bill_detail.description_delete">
                    ** {{ data_bill_detail.description_delete }} **
                </h2>
                <div class="report_bill_retrospect">
                    <div class="d-flex justify-space-between">
                        <div class="img_report_bill_retrospect">
                            <img :src="data_bill_detail.logo_image">
                        </div>
                        <div class="header_report_bill_retrospect">
                            <div>{{ data_bill_detail.name_bill }}</div>
                            <div>{{ data_bill_detail.address_bill }}</div>
                            <div>โทร. {{ data_bill_detail.tel_bill }}</div>
                        </div>
                    </div>
                    <div class="text-right">เลขที่ {{ data_bill_detail.code }}</div>
                    <div class="text-center" style="margin-top: -21px">ใบกำกับภาษีอย่างย่อ</div>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    อาหาร
                                </th>
                                <th class="text-left">
                                    จำนวน
                                </th>
                                <th class="text-right">
                                    รวม
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail_buffet,key) in data_bill_buffet" :key="key">
                                <td class="text-left">
                                    {{ detail_buffet.name }} ({{ detail_buffet.price }})
                                </td>
                                <td class="text-left">
                                    {{ detail_buffet.amount }}
                                </td>
                                <td class="text-right">
                                    {{ detail_buffet.total_price }}
                                </td>
                            </tr>

                            <tr v-for="(detail_nobuffet,key) in data_bill_nobuffet" :key="key">
                                <td class="text-left">
                                    <div>
                                        {{ detail_nobuffet.name }} ({{ detail_nobuffet.price }})
                                    </div>
                                    <div v-if="detail_nobuffet.extra">
                                        - ท็อปปิ้งเพิ่ม {{ detail_nobuffet.extra }}
                                    </div>
                                </td>
                                <td class="text-left">
                                    {{ detail_nobuffet.amount }}
                                </td>
                                <td class="text-right">
                                    {{ detail_nobuffet.total_price }}
                                </td>
                            </tr>

                            <tr>
                                <td class="text-right" colspan="2">
                                    รวมเงิน
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.price }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    ส่วนลด
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.discount }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    รวมทั้งสิ้น
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.total_price }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    เงินที่จ่าย
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.reccive_money }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="2">
                                    เงินทอน
                                </td>
                                <td class="text-right">
                                    {{ data_bill_detail.change }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div>
                    <v-btn dark class="white--text" width="100%" height="50" @click="open_confirm_print = true">พิมพ์ใบเสร็จ</v-btn>
                </div>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="alert_money_in_out" persistent max-width="600">
        <v-card>
            <v-form ref="form_remove_money_in_out" @submit.prevent="removeMoney_in_out()">
                <v-card-title>
                    ต้องการลบ
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการลบ เงินเข้า/เงินออก นี้ใช่หรือไม่ ??
                    </div>
                    <div class="mb-2">
                        <v-select label="เหตุผลในการยกเลิกเงินเข้า/เงินออก" v-model="remove_money_in_out_description" :items="$store.state.reasonCancelBill" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเหตุผลในการยกเลิกเงินเข้า/เงินออก']" @change="removeMoneyInOutDescription()" required outlined>
                        </v-select>
                    </div>
                    <div class="mb-2" v-if="remove_money_in_out_reason_check">
                        <v-text-field v-model="remove_money_in_out_reason" color="primary" label="เหตุผลในการยกเลิกบิล" :rules="[v => !!v || 'กรุณากรอกเหตุผลในการยกเลิกเงินเข้า/เงินออก']" required outlined></v-text-field>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="alert_money_in_out = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="open_confirm_print" persistent max-width="600">
        <v-card>
            <v-form @submit.prevent="printBill()">
                <v-card-title>
                    ต้องการลบ
                </v-card-title>

                <v-card-text>
                    <div class="mb-2">
                        ต้องการพิมพ์ใบเสร็จ นี้ใช่หรือไม่ ??
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" type="submit">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="open_confirm_print = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/ZoftConnect_Logo_Black_for_Bill_150px.png";
export default {
    name: 'billretrospect',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            loading_page_detail_bill: true,
            page: 1,
            alert_show: false,
            alert_waiting: false,
            confirm_bill: false,
            change_type_pay: false,
            bill_id: null,
            bill_description: null,
            bill_description_reason_check: false,
            bill_description_reason: null,
            bill_invoin_code: null,
            change_description: null,
            detail_bill: false,
            data_bill_detail: {
                logo_image: before_image,
                name_bill: null,
                address_bill: null,
                tel_bill: null,
                code: null,
                price: null,
                discount: null,
                total_price: null,
                reccive_money: null,
                change: null,
            },
            data_bill_buffet: [],
            data_bill_nobuffet: [],
            bill_search: '',
            bill_headers: [{
                    text: 'เลขที่ใบเสร็จ',
                    align: 'start',
                    value: 'invoin_code',
                },
                {
                    text: 'เวลา',
                    value: 'time'
                },
                {
                    text: 'ประเภท',
                    value: 'type'
                },
                {
                    text: 'ผู้ยกเลิก',
                    value: 'user_cancel'
                },
                {
                    text: 'ยอดขาย',
                    value: 'total_price'
                },
                {
                    text: 'การชำระเงิน',
                    value: 'payment_method'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'ดูรายละเอียด',
                    value: 'action'
                },
            ],
            change_pay_headers: [
                {
                    id: 1,
                    text: 'เงินสด',
                },
                {
                    id: 2,
                    text: 'เงินโอน'
                }
                
            ],
            bill_list: [],
            money_search: '',
            money_headers: [{
                    text: 'รายการ',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'วัน-เวลา',
                    align: 'date',
                    value: 'date'
                },
                {
                    text: 'ราคา',
                    value: 'price'
                },
                {
                    text: 'การชำระเงิน',
                    value: 'status'
                },
                {
                    text: 'หมายเหตุ',
                    value: 'description'
                },
                {
                    text: 'สถานะ',
                    value: 'action'
                },
            ],
            money_list: [],
            alert_money_in_out: false,
            remove_money_in_out_description: null,
            remove_money_in_out_reason_check: null,
            remove_money_in_out_reason: null,
            message_remove_money_in_out: false,
            open_confirm_print: false,
            print_id: null,
        }
    },
    methods: {
        async changePage(type) {
            this.page = type
            if (type === 1) {
                this.billList()
            }
            if (type === 2) {
                this.moneyInOutList()
            }
        },
        async billList() {
            this.loading_page = true
            HTTP.get('/POS/table/invoice-to-day', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bill_list = response.data.invoiceList
                        response.data.invoiceList.forEach((detail, index) => {
                            if (detail.payment_method == 0) this.bill_list[index].payment_method = 'สด'
                            else if (detail.payment_method == 1) this.bill_list[index].payment_method = 'โอน'
                            else this.bill_list[index].payment_method = '-'
                            this.bill_list[index].status = detail.status == 0 ? 'ยกเลิกบิล' : 'บิลถูกยกเลิก'
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async moneyInOutList() {
            this.loading_page = true
            HTTP.get('/moninouttoday', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.money_list = response.data.monInout
                        response.data.monInout.forEach((detail, index) => {
                            if (detail.status_delete == 0) {
                                this.money_list[index].status = detail.status === 1 ? 'เงินโอน' : 'เงินสด'
                                this.money_list[index].description = detail.description == null ? '-' : detail.description
                                this.money_list[index].action = 'ยกเลิกรายการ'
                            }
                            if (detail.status_delete == 1) {
                                this.money_list[index].status = 'ยกเลิก'
                                this.money_list[index].description = detail.description_delete == null ? '-' : detail.description_delete
                                this.money_list[index].action = 'รายการถูกยกเลิก'
                            }
                        })
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async cancelMoneyInOut(id) {
            this.alert_money_in_out = true
            this.money_in_out_delete_id = id
        },
        async removeMoneyInOutDescription() {
            this.remove_money_in_out_reason_check = false
            if (this.remove_money_in_out_description == 'อื่นๆ') {
                this.remove_money_in_out_reason_check = true
            }
        },
        async removeMoney_in_out() {
            if (this.$refs.form_remove_money_in_out.validate()) {
                this.alert_money_in_out = false
                this.loading_page_money_in_out = true
                let cancel_description = this.remove_money_in_out_description
                if (this.remove_money_in_out_reason_check) {
                    cancel_description = this.remove_money_in_out_reason
                }
                HTTP.post('/POS/money-in-outs-delete', {
                        id: this.money_in_out_delete_id,
                        description_delete: cancel_description,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.money_in_out_delete_id = null
                            this.remove_money_in_out_description = null
                            this.message_remove_money_in_out = true
                            setTimeout(() => this.message_remove_money_in_out = false, 5000)
                            this.moneyInOutList()
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })

            }
        },
        async changetypepay(id, invoin_code) {
            this.loading_page_detail = true
            this.bill_id = id
            this.bill_invoin_code = invoin_code
            this.loading_page_detail = false
            this.change_type_pay = true
        },
        async canceltypepay() {
            this.loading_page_detail = true
            this.loading_page_detail = false
            this.change_type_pay = false
        },
        async confirmBill(id, invoin_code) {
            this.loading_page_detail = true
            this.bill_id = id
            this.bill_invoin_code = invoin_code
            this.bill_description = null
            this.loading_page_detail = false
            this.confirm_bill = true
        },
        async cancelBill() {
            this.bill_id = null
            this.bill_invoin_code = null
            this.bill_description = null
            this.bill_description_reason_check = false
            this.bill_description_reason = null
            this.confirm_bill = false
        },
        async billCancelDescription() {
            this.bill_description_reason_check = false
            if (this.bill_description == 'อื่นๆ') {
                this.bill_description_reason_check = true
            }
        },
        async successBill() {
            if (this.$refs.form_successbill.validate()) {
                this.loading_page_detail = true
                let cancel_description = this.bill_description
                if (this.bill_description_reason_check) {
                    cancel_description = this.bill_description_reason
                }
                HTTP.post('/POS/table/invoice-update-status', {
                        id: this.bill_id,
                        description: cancel_description
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.confirm_bill = false
                            this.billList()
                            this.alert_show = true
                            setTimeout(() => this.alert_show = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async successChangePay() {
            if (this.$refs.form_successchangepay.validate()) {
                this.loading_page_detail = true
                let main_description = this.change_description

                HTTP.post('/POS/table/invoice-update-status-pay', {
                        id: this.bill_id,
                        description: main_description
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.change_type_pay = false
                            this.billList()
                            this.alert_show = true
                            setTimeout(() => this.alert_show = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async detailBill(id) {
            this.loading_page_detail_bill = true
            this.detail_bill = true
            this.data_bill_detail = {
                logo_image: before_image,
                name_bill: null,
                address_bill: null,
                tel_bill: null,
                code: null,
                price: null,
                discount: null,
                total_price: null,
                reccive_money: null,
                change: null,
                description_delete: null,
            }
            this.data_bill_buffet = []
            this.data_bill_nobuffet = []
            this.print_id = id
            HTTP.get('/POS/table/invoice-detaile/' + id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data_bill_detail = response.data.invoiceDetaile
                        this.data_bill_buffet = response.data.listBuffet
                        this.data_bill_nobuffet = response.data.listnoBuffet
                        this.loading_page_detail_bill = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async printBill() {
            this.open_confirm_print = false
            HTTP.post('/printlastagain/' + this.print_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.print_id = null
                        this.alert_waiting = true
                        setTimeout(() => this.alert_waiting = false, 5000)
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
    },
    mounted() {
        this.billList()
    }
}
</script>
